import { render } from "./wfm-list-icons.vue?vue&type=template&id=63425eb8&scoped=true"
import script from "./wfm-list-icons.vue?vue&type=script&lang=js"
export * from "./wfm-list-icons.vue?vue&type=script&lang=js"

import "./wfm-list-icons.vue?vue&type=style&index=0&id=63425eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63425eb8"]])

export default __exports__